module.exports = {"version":"v2"}


//////////////////
// WEBPACK FOOTER
// ./src/api-version.json
// module id = 25
// module chunks = 0